export default __webpack_public_path__ + "static/media/html-5.e7638e36.svg";